<div class="d-lg-none">
  <fgb-mobile-page-header pageTitle="polls.page.banner" [showQr]="true" [backButtonLink]="'/games'"></fgb-mobile-page-header>
</div>

<div class="games-banner" [ngClass]="isCorporate ? 'bg-corporate-primary' : 'bg-primary'">
  <div class="container">
    <div class="games-banner-frame">
      <a class="games-banner-buttons d-lg-flex d-none text-white align-items-center" [routerLink]="['/games']">
        <i class="material-icons">chevron_left</i>
        <span class="font-size-14 fw-bold">{{ 'games.banner.back.title' | translate }}</span>
      </a>
      <div class="banner-img-container">
        <img [src]="'banners/polls-banner.jpg' | contentAssetImage" alt="Games Banners" class="games-banner-banners" />
      </div>
    </div>
  </div>
</div>

<div class="container mobile-container">
  <div class="pt-lg-3">
    <ng-container *ngIf="pollsQuestion$ | async as pollsQuestions; else shimmerEffect">
      <ng-container *ngIf="pollsQuestions.length > 0">
        <fgbcl-game-polls-question-list [pollsQuestions]="pollsQuestions"> </fgbcl-game-polls-question-list>
      </ng-container>
    </ng-container>
  </div>

  <!-- Shimmer Effect -->
  <ng-template #shimmerEffect>
    <div class="card" aria-hidden="true" *ngFor="let i of [1, 2, 3]">
      <h6 class="card-title placeholder-glow text-center">
        <span class="question-shimmer-effect placeholder col-6"></span>
      </h6>
      <div class="answer-shimmer-effect-section">
        <p class="card-text placeholder-glow w-100 mb-0 text-center">
          <span class="answer-shimmer-effect placeholder col-12"></span>
        </p>
        <p class="card-text placeholder-glow w-100 mb-0 text-center">
          <span class="answer-shimmer-effect placeholder col-12"></span>
        </p>
      </div>
      <div class="answer-shimmer-effect-section mt-3">
        <p class="card-text placeholder-glow w-100 mb-0 text-center">
          <span class="answer-shimmer-effect placeholder col-12"></span>
        </p>
        <p class="card-text placeholder-glow w-100 mb-0 text-center">
          <span class="answer-shimmer-effect placeholder col-12"></span>
        </p>
      </div>
      <div class="d-flex align-items-center justify-content-center">
        <p class="card-text placeholder-glow w-40 text-center">
          <span class="presentby-shimmer-effect placeholder col-7"></span>
        </p>
      </div>
    </div>
  </ng-template>
</div>
